import BlurImageBackground from "@/components/BlurImageBackground";
import DetailButton from "@/components/DetailButton";
import SliderCore from "@/components/SliderCore";
import VersatileLink from "@/components/VersatileLink";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";
import routes from "@/lib/routes";
import styles from "@/styles/Carousel.module.scss";
import Image from "next/legacy/image";
import { useMemo } from "react";

const sliderOptions = {
  slidesPerView: 1,
  slidesPerGroup: 1,
  navigation: true,
  pagination: { clickable: true },
  speed: 500,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
};

function CarouselItem({ item }) {
  const detailLink = useMemo(() => {
    if (item.__typename === "EpisodeMeta" || item.__typename === "LiveMeta") {
      return routes.watch(item.id);
    } else if (item.__typename === "TVShowMeta") {
      return routes.title(item.id);
    } else if (item.__typename === "ChannelMeta") {
      return routes.channelDetail(item.id);
    } else if (item.__typename === "Advert") {
      return item.url;
    }
  }, [item]);

  const imagePreloadOption = { priority: true, loading: "eager" };

  const channelId = Number(item?.channel?.id);
  const showValuePlanLabel = isShowValuePlanLabel({ channelId });

  return (
    <div className={styles.item}>
      <BlurImageBackground
        className={"carousel"}
        item={item}
        imageOptions={imagePreloadOption}
      >
        <div className={styles.content}>
          <div className={styles.info}>
            <div className={styles.title}>
              <VersatileLink href={detailLink}>{item.name}</VersatileLink>
            </div>
            <p className={styles.description}>{item.description}</p>
            <DetailButton href={detailLink} className={styles.detailBtn} />
          </div>
          <div className={styles.artwork}>
            <VersatileLink href={detailLink} className={styles.link}>
              {!!item?.thumbnailUrl && (
                <Image
                  src={item.thumbnailUrl}
                  alt={item.name}
                  width={704}
                  height={396}
                  layout="responsive"
                  {...imagePreloadOption}
                />
              )}
              {showValuePlanLabel && (
                <div className={styles.valueplanLabel}>
                  <Image
                    src={"/images/valueplan_label.png"}
                    alt={"valueplan_label"}
                    layout="fill"
                    objectFit="cover"
                  ></Image>
                </div>
              )}
            </VersatileLink>
          </div>
        </div>
      </BlurImageBackground>
    </div>
  );
}

export default function Carousel({ items }) {
  return (
    <div className={styles.container}>
      {items && (
        <SliderCore sliderOptions={sliderOptions}>
          {items.map((item, i) => (
            <CarouselItem item={item} key={`carousel-${i}`} />
          ))}
        </SliderCore>
      )}
    </div>
  );
}
